export default __webpack_public_path__ + "static/media/plain-sticker-e.acc94f51.png";